import { render, staticRenderFns } from "./table-no-sign.vue?vue&type=template&id=289cb16f&"
import script from "./table-no-sign.vue?vue&type=script&lang=ts&"
export * from "./table-no-sign.vue?vue&type=script&lang=ts&"
import style0 from "./table-no-sign.vue?vue&type=style&index=0&id=289cb16f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports